import { render, staticRenderFns } from "./GenerateInvoicePage.vue?vue&type=template&id=2a2ccbb5&"
import script from "./GenerateInvoicePage.vue?vue&type=script&lang=js&"
export * from "./GenerateInvoicePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports